import { ca } from '@cian/analytics';

import { TRegularInfrastructureItem } from '../../../types/map';
import { hasFutureObjects } from '../../../utils/map';

export function trackInfrastructureShow(
  infrastructureItems: TRegularInfrastructureItem[],
  isMapServicesEnabled: boolean,
  hasTransportAccessibilityServiceVisible: boolean,
) {
  // TODO: Удалить условие в NB-1172, если будет принято решение оставить редизайн.
  if (!isMapServicesEnabled) {
    ca('eventSite', {
      action: 'show_sopr',
      category: 'CardJK',
      label: 'infrastructure',
      name: 'oldevent',
      useLastProducts: true,
    });

    return;
  }

  let blockType;

  if (hasTransportAccessibilityServiceVisible) {
    blockType = 'future_plus_index';
  } else if (hasFutureObjects(infrastructureItems)) {
    blockType = 'future';
  } else {
    blockType = 'standard';
  }

  ca('eventSite', {
    action: 'show_sopr',
    category: 'CardJK',
    label: 'infrastructure',
    name: 'oldevent',
    useLastProducts: true,
    page: {
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: { block_type: blockType },
    },
  });
}
